module.exports = __webpack_public_path__ + "52d90442d3c3dc18d3638d49ec5260a6.jpg";